<template>
  <div id="app">
    <transition :name="ransitionName">
      <router-view class="fixed-view"/>
    </transition>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import ResizeMixin from '@/views/index/mixin/ResizeHandler'

export default {
  name: 'App',
  mixins: [ResizeMixin],
  computed: {
    ...mapGetters([
      'transitionName'
    ]),
    ransitionName () {
      return this.transitionName;
    }
  }
}
</script>

<style lang="scss">
  html, body {
    height: 100%;
    width: 100%;
  }
  .fixed-view {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    margin: auto;
    background-color: #ffffff;
  }

  #app {
    height: 100%;
    width: 100%;
    /*font-family: "Helvetica Neue", "Avenir", Helvetica, Arial, "PingFang SC", "Hiragino Sans GB", "Heiti SC", "Microsoft YaHei", "WenQuanYi Micro Hei", sans-serif;*/
    font-family: Alibaba PuHuiTi-Heavy, Alibaba PuHuiTi;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 0.4266666666666667rem;
    line-height: 1.5;
    color: #333;
    overflow: hidden;
    /*background-color: #0F2751;*/
  }

  /*切换页面时的滑动效果*/
  .views {
    transition: all .8s ease;
  }

  .slide-left-enter-active {
    transition: all .3s ease;
  }

  .slide-left-leave-active {
    transition: all .4s ease;
  }

  .slide-left-enter {
    transform: translateX(100%);
    /*opacity: 0;*/
  }

  .slide-left-leave-to {
    transform: translateX(-100%);
    /*opacity: 0;*/
  }

  .slide-right-enter-active {
    transition: all .3s ease;
  }

  .slide-right-leave-active {
    transition: all .4s ease;
  }

  .slide-right-enter {
    transform: translateX(-100%);
    /*opacity: 0;*/
  }

  .slide-right-leave-to {
    transform: translateX(100%);
    /*opacity: 0;*/
  }


  .pc-home {
    /* 设置滚动条的样式 */
    ::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }

    /* 滚动槽 */
    ::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(255, 255, 255, 0.1);
      border-radius: 2px;
      background: rgba(255, 255, 255, 0.1);
    }

    /* 滚动条滑块 */
    ::-webkit-scrollbar-thumb {
      background: rgba(255, 255, 255, 0.1);
      -webkit-box-shadow: inset 0 0 6px rgba(255, 255, 255, 0.1);
    }
  }
  .van-notify{ font-size: .43rem !important; line-height: normal !important;}

</style>


